export enum applicationTypeIdEnum {
  APPLICATION = 1,
  LEGACY_APPLICATION = 2,
  GWT = 3,
  LANDING = 4,
  PANEL = 5,
  EXTERNAL = 6,
}

export enum ExceptionTypeIDEnum {
  KONKOR_SIMULATOR = 7,
}
